<template>
  <!-- 报名详情--未通过 -->
  <div class="passedExam">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input v-model.trim="query.query" placeholder="请输入姓名" style="width: 200px" @keyup.enter.native="frechLoad"
          @clear="
            query.query = '';
          frechLoad();
                                                          " clearable suffix-icon="el-icon-search"></el-input>
        <Debounce>
          <el-button style="margin:0px 10px;" size="small" @click="frechLoad">查询</el-button>
        </Debounce>
        <el-select v-model="query.provinceId" filterable @change="frechLoad" placeholder="请选择">
          <el-option label="全部省份" value=""></el-option>
          <el-option v-for="item in proList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.examSite" @change="frechLoad" filterable placeholder="请选择">
          <el-option label="全部市代" value=""></el-option>
          <el-option v-for="item in examSitList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.testLevel" @change="frechLoad" filterable placeholder="请选择">
          <el-option label="全部等级" value=""></el-option>
          <el-option v-for="item in lvList" :key="item.id" :label="item.lv" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.registrationSite" @change="frechLoad" filterable placeholder="请选择">
          <el-option label="全部考点" value=""></el-option>
          <el-option v-for="item in rationSiteList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>

    </el-row>
    <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;"
      :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中"
      :height="$store.getters.getTableHeight - 50">
      <el-table-column prop="name" label="姓名" width="120" align="center"></el-table-column>
      <el-table-column width="100" label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.sex === 1 ? "男" : "女" }}
        </template>
      </el-table-column>
      <el-table-column prop="age" width="100" label="年龄" align="center"></el-table-column>
      <el-table-column prop="provinceName" label="省份" align="center"></el-table-column>
      <el-table-column prop="examSiteName" label="市级代理" align="center"></el-table-column>
      <el-table-column prop="registrationPointName" label="考点" align="center"></el-table-column>
      <el-table-column prop="subjectName" label="报考科目" align="center"></el-table-column>
      <el-table-column prop="testLevel" label="报考等级" width="100" align="center"></el-table-column>
      <el-table-column label="考试视频" width="100" align="center">
        <template slot-scope="{$index,row}">
          <el-button type="text" @click="goVideo($index)">查看视频</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content"
      @pagination="tableLoad" />
  </div>
</template>

<script>
export default {
  props: ["infoId"],
  name: 'passedVideo',
  data() {
    return {
      tableList: [],
      tableSelectList: [],
      proList: [], //省份考点下拉菜单
      registerList: [], //报考等级下拉
      examSitList: [], //市代下拉菜单
      rationSiteList: [], // 考点下拉框
      tableIsLoad: true,
      query: {
        query: "",
        registrationSite: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        type: 1, //状态 1:已通过 0：待审核
        examSite: "", //所属市级代理
        provinceId: "", //所属省份ID
        testLevel: "", //报考等级
        examId: '',
      },
      lvList: [
        { id: 1, lv: "一级" },
        { id: 2, lv: "二级" },
        { id: 3, lv: "三级" },
        { id: 4, lv: "四级" },
        { id: 5, lv: "五级" },
        { id: 6, lv: "六级" },
        { id: 7, lv: "七级" },
        { id: 8, lv: "八级" },
        { id: 9, lv: "九级" },
        { id: 10, lv: "十级" },
        { id: 11, lv: "初级" },
        { id: 12, lv: "中级" },
        { id: 13, lv: "高级" },
      ],
    };
  },
  mounted() {
    this.query.examId = this.infoId;
    if (this.infoId == null) {
      return;
    }
    this.tableLoad();
    this.getSelectList();
  },
  methods: {
    frechLoad() {
      this.query.pageNum = 1
      this.tableLoad()
    },
    goVideo(index) {
      this.$emit('showDialog', index, this.tableList, 1)
    },
    tableLoad() {
      this.tableIsLoad = true;
      this.$axios.post("/videoVerify/detail", this.query).then((res) => {
        let {
          list,
          total
        } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.$nextTick(item => {
          this.$refs.elTable.doLayout();
        })
        this.tableIsLoad = false;
      });
    },
    // 全部下拉菜单
    getSelectList() {
      this.$axios.get("/process/newProvince").then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get("/process/examinationSite").then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
      this.$axios.get("/process/examinationSite").then((res) => {
        let data = res.data.data;
        this.rationSiteList = data;
      });
    },
    getRegList() {
      this.$axios
        .get(`/process/register/${this.query.examSite}`)
        .then((res) => {
          let data = res.data.data;
          this.registerList = data;
        });
    },
    proChange(val) {
      // this.query.examSite = "";
      // if (val == "") {
      //   this.examSitList = [];
      // } else {
      //   let proObj = this.proList.find((item) => item.provinceId === val);
      //   this.examSitList = proObj.examSiteVOS;
      // }
      this.tableLoad();
    },
    examChange(val) {
      // this.registerList = [];
      // this.query.registrationSite = '';
      // if (val) {
      //   this.getRegList();
      // }
      this.tableLoad();
    },
  },
};
</script>

<style lang="scss" scoped>
.tableHearInputBox {
  .el-select {
    width: 200px;
    margin-right: 10px;
  }
}

.contentBox {
  padding: 0px 20px 10px 20px;

  p {
    line-height: 1.5;
  }
}

.dialogBox {
  p {
    margin-bottom: 5px;
  }
}

.spanStyle {
  color: #f56c6c;
  text-decoration: underline;
}
</style>
